import path from 'path';

const APP_STORE_ID = '1324102258';
const IOS_APP_BUNDLE_ID = 'ibi=com.rabbl.Blink';
const ANDROID_AP_PACKAGE_NAME = 'com.rabbl.blinq';

export function createDeepLink(
  link: string,
  iosMinimumVersion = '1.3.17',
  androidMinimumVersion = '1.2.12',
): string {
  const deepLink = `https://blinqapp.page.link/?link=${encodeURIComponent(
    link,
  )}&ibi=${APP_STORE_ID}&isi=${IOS_APP_BUNDLE_ID}&apn=${ANDROID_AP_PACKAGE_NAME}&imv=${iosMinimumVersion}&amv=${androidMinimumVersion}`;

  return deepLink;
}

/**
 * Creates a phone number link that can be used in an anchor tag
 * @param phoneNumber The phone number to dial
 * @param extension The extension numbers to dial once the call has connected
 * @see https://stackoverflow.com/a/67810744/12385086
 */
export function createPhoneNumberLink(phoneNumber: string, extension?: string): string {
  const trimmedPhoneNumber = phoneNumber.replace(/[\s()-]/g, '');
  if (!extension) return `tel:${trimmedPhoneNumber}`;
  else return `tel:${trimmedPhoneNumber}, ${extension}`;
}

export const removeUrlScheme = (url: string): string => {
  if (url.startsWith('https://')) {
    return url.split(/https:\/\//)[1];
  }
  if (url.startsWith('http://')) {
    return url.split(/http:\/\//)[1];
  }
  return url;
};

export function buildUrl(...parts: string[]): string {
  return new URL(path.join(...parts)).toString();
}

export function removePortFromUrl(url: string): string {
  const urlObject = new URL(url);
  urlObject.port = '';
  return urlObject.toString();
}

export function replaceUrlHost(url: string, newHost: string): string {
  const parsedUrl = new URL(url);
  parsedUrl.host = newHost;
  return parsedUrl.toString();
}
